import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_2 = {
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "address-data-form:FullName"
}
const _hoisted_3 = {
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "address-data-form:Country"
}
const _hoisted_4 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_5 = {
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "address-data-form:City"
}
const _hoisted_6 = {
  key: "stateOrProvince",
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "address-data-form:StateOrProvince"
}
const _hoisted_7 = {
  key: "subLocationID",
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "address-data-form:SubLocation"
}
const _hoisted_8 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_9 = {
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "address-data-form:PostalCode"
}
const _hoisted_10 = {
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "address-data-form:AddressLine1"
}
const _hoisted_11 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_12 = {
  key: 0,
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "address-data-form:AddressLine2"
}
const _hoisted_13 = {
  key: 1,
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "address-data-form:AddressLine3"
}
const _hoisted_14 = {
  key: 2,
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "address-data-form:PhoneNumber"
}
const _hoisted_15 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_16 = {
  key: 0,
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "address-data-form:PhoneNumber"
}
const _hoisted_17 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_18 = {
  key: 0,
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "address-data-form:Notes"
}
const _hoisted_19 = {
  key: 1,
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "address-data-form:LocalizedAddress"
}
const _hoisted_20 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_21 = {
  key: 0,
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "address-data-form:VatNumber"
}
const _hoisted_22 = { class: "gfu-grid__cell gfu-1of1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_option_field = _resolveComponent("option-field")
  const _component_text_area_field = _resolveComponent("text-area-field")
  const _component_vat_reverse_checkbox = _resolveComponent("vat-reverse-checkbox")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("fieldset", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_text_field, {
          modelValue: $data.model.fullName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.fullName) = $event)),
          name: "model.fullName",
          "display-name": $options.fullNameLabel,
          disabled: $options.isFullAddressDisabled
        }, null, 8 /* PROPS */, ["modelValue", "display-name", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_option_field, {
          modelValue: $data.model.projectLocationID,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = $event => (($data.model.projectLocationID) = $event)),
            $options.onLocationChange
          ],
          name: "model.projectLocationID",
          "display-name": _ctx.Resources.Checkout.UserCountryLabel,
          options: $options.availableProjectLocationsOptions,
          disabled: $options.isProjectLocationDisabled
        }, null, 8 /* PROPS */, ["modelValue", "display-name", "options", "disabled", "onUpdate:modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_text_field, {
          modelValue: $data.model.city,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.model.city) = $event)),
          name: "model.city",
          "display-name": _ctx.Resources.Checkout.UserCityLabel,
          disabled: $options.isFullAddressDisabled
        }, null, 8 /* PROPS */, ["modelValue", "display-name", "disabled"])
      ]),
      ($options.projectSubLocations.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_text_field, {
              modelValue: $data.model.stateOrProvince,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.model.stateOrProvince) = $event)),
              name: "model.stateOrProvince",
              "display-name": _ctx.Resources.Checkout.UserStateOrProvinceLabel,
              disabled: $options.isFullAddressDisabled
            }, null, 8 /* PROPS */, ["modelValue", "display-name", "disabled"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_option_field, {
              modelValue: $data.model.projectSubLocationID,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = $event => (($data.model.projectSubLocationID) = $event)),
                $options.onSublocationChange
              ],
              name: "model.projectSubLocationID",
              "display-name": _ctx.Resources.Checkout.UserStateOrProvinceLabel,
              options: $options.availableProjectSubLocationsOptions,
              disabled: $options.isProjectSubLocationDisabled
            }, null, 8 /* PROPS */, ["modelValue", "display-name", "options", "disabled", "onUpdate:modelValue"])
          ]))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_text_field, {
          modelValue: $data.model.postalCode,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.model.postalCode) = $event)),
          name: "model.postalCode",
          "display-name": _ctx.Resources.Checkout.UserPostalCodeLabel,
          disabled: $options.isFullAddressDisabled
        }, null, 8 /* PROPS */, ["modelValue", "display-name", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_text_field, {
          modelValue: $data.model.addressLine1,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.model.addressLine1) = $event)),
          name: "model.addressLine1",
          "display-name": $options.addressLabel,
          disabled: $options.isFullAddressDisabled
        }, null, 8 /* PROPS */, ["modelValue", "display-name", "disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      ($data.effectiveShowAddressLine2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_text_field, {
              modelValue: $data.model.addressLine2,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.model.addressLine2) = $event)),
              name: "model.addressLine2",
              "display-name": _ctx.Resources.Checkout.UserSecondAddressLabel,
              disabled: $options.isFullAddressDisabled
            }, null, 8 /* PROPS */, ["modelValue", "display-name", "disabled"])
          ]))
        : _createCommentVNode("v-if", true),
      ($data.effectiveShowAddressLine3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_text_field, {
              modelValue: $data.model.addressLine3,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($data.model.addressLine3) = $event)),
              name: "model.addressLine3",
              "display-name": _ctx.Resources.Checkout.UserThirdAddressLabel,
              disabled: $options.isFullAddressDisabled
            }, null, 8 /* PROPS */, ["modelValue", "display-name", "disabled"])
          ]))
        : _createCommentVNode("v-if", true),
      ($data.effectiveShowAddressLine2 && !$data.effectiveShowAddressLine3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_text_field, {
              modelValue: $data.model.phoneNumber,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($data.model.phoneNumber) = $event)),
              name: "model.phoneNumber",
              "display-name": _ctx.Resources.Checkout.UserPhoneNumberLabel,
              disabled: $props.readOnly
            }, null, 8 /* PROPS */, ["modelValue", "display-name", "disabled"])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      (!($data.effectiveShowAddressLine2 && !$data.effectiveShowAddressLine3))
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_text_field, {
              modelValue: $data.model.phoneNumber,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($data.model.phoneNumber) = $event)),
              name: "model.phoneNumber",
              "display-name": _ctx.Resources.Checkout.UserPhoneNumberLabel,
              disabled: $props.readOnly
            }, null, 8 /* PROPS */, ["modelValue", "display-name", "disabled"])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_17, [
      ($data.effectiveShowNotes)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_text_area_field, {
              modelValue: $data.model.notes,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($data.model.notes) = $event)),
              name: "model.notes",
              "display-name": _ctx.Resources.Checkout.UserNotesLabel,
              description: "",
              disabled: $props.readOnly,
              rows: "4"
            }, null, 8 /* PROPS */, ["modelValue", "display-name", "disabled"])
          ]))
        : _createCommentVNode("v-if", true),
      ($options.hasShippingLocalizedAddressRules)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(_component_text_area_field, {
              modelValue: $data.model.shippingLocalizedAddress,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($data.model.shippingLocalizedAddress) = $event)),
              name: "model.shippingLocalizedAddress",
              "display-name": _ctx.Resources.Checkout.LocalizedAddressLabel,
              description: "",
              "tooltip-text": $options.shippingLocalizedAddressRules.tooltip,
              disabled: $props.readOnly,
              rows: "4"
            }, null, 8 /* PROPS */, ["modelValue", "display-name", "tooltip-text", "disabled"])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_20, [
      ($options.showVatID)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createVNode(_component_text_field, {
              modelValue: $data.model.vatNumber,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (($data.model.vatNumber) = $event)),
              name: "model.vatNumber",
              "display-name": $options.customerVatNumberFieldName,
              "tooltip-text": $options.customerVatNumberFieldRules.tooltip,
              disabled: $options.isVatPayerFieldsDisabled
            }, null, 8 /* PROPS */, ["modelValue", "display-name", "tooltip-text", "disabled"])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_22, [
        ($props.isRegisteredVatPayerCheckboxVisible)
          ? (_openBlock(), _createBlock(_component_vat_reverse_checkbox, {
              key: 0,
              modelValue: $data.model.isRegisteredVatPayer,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($data.model.isRegisteredVatPayer) = $event)),
              "tax-regulation": $options.projectLocation.taxRegulation,
              class: "_mt-2",
              disabled: "",
              "data-qa": "begin-order-form:validateVat"
            }, null, 8 /* PROPS */, ["modelValue", "tax-regulation"]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}